var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownShort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.42 6.72-1.17-1.14A1.86 1.86 0 0 0 21 5a1.8 1.8 0 0 0-1.5.57l-7.5 7.4-7.5-7.4A1.8 1.8 0 0 0 3 5c-.47.02-.92.22-1.25.57L.6 6.72C.24 7.05.02 7.52 0 8a1.8 1.8 0 0 0 .6 1.38l10.02 10.04A1.8 1.8 0 0 0 12 20a1.92 1.92 0 0 0 1.4-.57l10.02-9.95A1.8 1.8 0 0 0 24 8a1.89 1.89 0 0 0-.57-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownShort);
export default __webpack_public_path__ + "static/media/arrow-down-short.3e79437ff695bff53de3e6700fe3a43f.svg";
export { ForwardRef as ReactComponent };